import { ScriptableContext } from 'chart.js';
import { ComplexFillTarget } from 'chart.js/dist/types';
import { primaryColourMain } from 'app/agriculture/material';

export function genericSparkChartBackgroundColor(
    context: ScriptableContext<'line'>,
): ComplexFillTarget {
    const {
        chart: { ctx: chart },
    } = context;

    // if the chart hasn't loaded yet
    if (!context.chart.scales.y) {
        return {
            target: 'origin',
            above: 'rgb(0,0,0)',
            below: 'rgb(0,0,0)',
        } as const satisfies ComplexFillTarget;
    }

    const positiveGradient = chart.createLinearGradient(0, 0, 0, context.chart.height);
    positiveGradient.addColorStop(0, primaryColourMain);
    positiveGradient.addColorStop(1, `${primaryColourMain}00`);

    const negativeGradient = chart.createLinearGradient(0, 0, 0, context.chart.height);
    negativeGradient.addColorStop(1, primaryColourMain);
    negativeGradient.addColorStop(0, `${primaryColourMain}00`);

    return {
        target: 'start',
        above: positiveGradient,
        below: negativeGradient,
    } as const satisfies ComplexFillTarget;
}

export function emptyStateSparkChartBackgroundColor(
    context: ScriptableContext<'line'>,
): ComplexFillTarget {
    const {
        chart: { ctx: chart },
    } = context;

    // if the chart hasn't loaded yet
    if (!context.chart.scales.y) {
        return {
            target: 'origin',
            above: 'rgb(0,0,0)',
            below: 'rgb(0,0,0)',
        };
    }

    const positiveGradient = chart.createLinearGradient(0, 0, 0, context.chart.height);
    positiveGradient.addColorStop(0, 'rgba(0, 0, 0, 0.2)');
    positiveGradient.addColorStop(1, 'rgba(0, 0, 0, 0)');

    const negativeGradient = chart.createLinearGradient(0, 0, 0, context.chart.height);
    negativeGradient.addColorStop(1, 'rgba(0, 0, 0, 0.2)');
    negativeGradient.addColorStop(0, 'rgba(0, 0, 0, 0)');

    return {
        target: 'start',
        above: positiveGradient,
        below: negativeGradient,
    };
}
